<template>
  <dy-dialog v-model="visible" width="70%" title="选择车位" confirm-title="确定" :show-confirm="multiple ? !!selectRows.length : !!selectRow"
    @onConfirm="handleSelected" @onClose="handleClose">
    <dy-main-container class="select-asset-dialog" hide-top-menu>
      <template #left>
        <DyOrgManagement ref="leftTreeRef" :table-list-api="api.getCarParkTree" data-path="data"
          :width="dividerOption.leftAsideWidth" :table-columns="tableColumns" @defaultSelected="handleOrgSelected"
          @onchange="handleOrgSelected" />
      </template>
      <template #right>
        <avue-crud ref="crud" :page.sync="page" :data="tableList" :table-loading="tableLoading" :option="avueOption"
          @search-change="searchChange" @row-click="rowClick" @on-load="getList" :search.sync="searchForm"
          @selection-change="selectionChange"
          @search-reset="resetChange">
          <template slot="radio" slot-scope="{row}">
            <el-radio v-model="selectRowIndex" :label="row.$index">&nbsp;</el-radio>
          </template>
        </avue-crud>
      </template>
    </dy-main-container>
    <DySelectCustomerDialog ref="selectCustomerRef" @confirm="handleCustomerSelected" />
  </dy-dialog>
</template>

<script>
import DyDialog from "@/components/DYDialog/index.vue";
import DyMainContainer from "@/components/DYMainContainer/index.vue";
import { getTableOption } from "@/const/crud/baseData/carport";
import { getCarParkTree, getCarSpotList } from "@/api/v3/assets/carport";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "DySelectCarportDialog",
  components: { DyMainContainer, DyDialog },
  data() {
    return {
      visible: false,
      assetType: 0,
      orgInfo: undefined,
      selectRow: undefined,
      selectRows: [],
      selectRowIndex: undefined,
      multiple: false,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      dividerOption: {
        leftAsideWidth: 225,
        leftAsideMinWidth: 200,
      },
      searchForm: {},
      api: {
        getCarParkTree: () =>
          getCarParkTree({ projectCode: this.project.code }),
      },
      avueOption: undefined,
      tableList: undefined,
      tableLoading: false,
      tableColumns: [
        {
          label: "名称",
          prop: "name",
          width: "60",
          mainColumn: true,
          mainColumnIcon: (row, index) => {
            return row.type === "CW-CWLX-BZCW" ? "icon-file" : "icon-folder";
          },
        },
      ],
    };
  },
  computed: {
    project() {
      return store.getters.project;
    },
  },
  methods: {
    open(params) {
      const { searchParams, resolve, cancel, multiple } = params || {};
      this.resolve = resolve;
      this.cancel = cancel;
      this.multiple = !!multiple;
      this.selectRow = undefined;
      this.selectRows = [];
      this.selectRowIndex = undefined;
      const avueOption = getTableOption(this);
      avueOption.menu = false;
      avueOption.index = false;
      avueOption.height = 380;
      // const columns = ['code', 'name', 'pid', 'enableStatusDisaccount', 'enableLatefee', 'enableInvoice', 'invoiceTaxRate', 'enableLatefee', 'latefeeChargeRatio']
      // avueOption.column = avueOption.column.filter(item => columns.includes(item.prop))
      avueOption.selection = this.multiple;
      if (!this.multiple) {
        avueOption.column.unshift({
          prop: "radio",
          width: 60,
        });
      }
      this.avueOption = avueOption;
      this.visible = true;
      Object.assign(this.searchForm, searchParams);
    },
    handleOrgSelected(org) {
      if (!org?.id) return;
      this.orgInfo = org;
      this.getList();
    },
    searchChange(form, done) {
      this.getList();
      done && done();
    },
    async getList() {
      this.tableLoading = true;
      const form = {
        ...this.searchForm,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        pid: this.orgInfo.id,
        projectCode: this.project.code,
      };
      const res = await getCarSpotList(form);
      this.tableList =
        res.data.records?.map((item) => {
          item.usageStatus = item.usageStatus + "";
          return item;
        }) || [];
      this.page.total = Number(res.data.total);
      this.tableLoading = false;
    },
    handleSelected() {
      this.visible = false;
      const result = this.multiple ? this.selectRows : this.selectRow;
      this.$emit("confirm", result);
      this.resolve && this.resolve(result);
    },
    handleClose() {
      this.selectRow = undefined;
      this.selectRows = [];
      this.selectRowIndex = undefined;
      this.cancel && this.cancel();
    },
    rowClick(row) {
      if (this.multiple) return;
      this.selectRow = row;
      this.selectRowIndex = row.$index;
    },
    selectionChange(rows) {
      this.selectRows = rows || [];
    },
    openSelectCustomer() {
      this.$refs.selectCustomerRef.open();
    },
    handleCustomerSelected(customerInfo) {
      this.searchForm.customerId = customerInfo.id;
      this.searchForm.customerName = customerInfo.name;
    },
    resetChange() {
      this.searchForm = this.$options.data().searchForm;
      this.searchChange();
    },
  },
};
</script>

<style scoped lang="scss">
.select-asset-dialog {
  height: 515px;
  overflow: hidden;
}

::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid rgba(236, 236, 236, 0.89);
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(236, 236, 236, 0.89);
  }
  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
